import { Fragment, useEffect, useRef, useState } from "react";
import { Col, Form, InputGroup, Button, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import socket from "./socket";
import {
  getWhatsappTemplate,
  getWhatsappTemplateVarCount,
  resetListRecord,
  sendMessage,
  userWiseMessage,
} from "../../reducers/commonReducer";
import TemplateInputFields from "./TemplateInputFields";
import icon from "../../images/chat-icon.png";
import { baseUrl } from "../../const";

const ChatArea = () => {
  const dispatch = useDispatch();
  const [message, setMessage] = useState("");
  const [page, setPage] = useState(1);
  const [selectedTemp, setSelectedTemp] = useState("");
  const [tempReco, setTempReco] = useState("");
  const [temInputFields, setTemInputFields] = useState(0);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [images, setImages] = useState();
  const [uploadImage, setUploadImage] = useState();
  const [contentType, setContentType] = useState("text");
  const fileInputRef = useRef(null);
  const chatBodyRef = useRef(null);
  const queryParams = new URLSearchParams(window.location.search);
  let userId = queryParams.get("userid");
  let username = queryParams.get("username");
  let name = queryParams.get("name");
  let tempUser = queryParams.get("tempUser");

  const {
    userWiseMessageList,
    whatsappTemplateList,
    customerLastMsgTime,
    whtspVarCount,
  } = useSelector((state) => state.commonReducer);

  const scrollToBottom = () => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  };
  useEffect(() => {
    dispatch(
      getWhatsappTemplate({
        status: true,
      })
    );
  }, []);
  useEffect(() => {
    dispatch(userWiseMessage({ userid: userId, page }));
    setSelectedTemp("");
  }, [userId, page]);
  //onLoad message
  useEffect(() => {
    setMessages((prev) => {
      const newMessageIds = new Set(prev.map((m) => m._id || m.createdAt));
      const uniqueMessages = userWiseMessageList.filter(
        (msg) => !newMessageIds.has(msg._id || msg.createdAt)
      );
      return page === 1 ? userWiseMessageList : [...uniqueMessages, ...prev];
    });
  }, [page, userWiseMessageList]);
  //get New Message
  useEffect(() => {
    const handleNewMessage = (newMsg) => {
      const newMsgWithObject = JSON.parse(newMsg);
      console.log("Received new message:", newMsgWithObject);
      if (userId === newMsgWithObject?.sender) {
        setMessages((prev) => {
          const isDuplicate = prev.some(
            (msg) =>
              (msg._id || msg.createdAt) ===
              (newMsgWithObject._id || newMsgWithObject.createdAt)
          );
          if (isDuplicate) return prev;
          return [...prev, newMsgWithObject];
        });
        scrollToBottom();
      }
    };
    socket.on("newMessage", handleNewMessage);
    return () => {
      socket.off("newMessage", handleNewMessage);
    };
  }, [userId, socket]);

  useEffect(() => {
    const handleStatusUpdate = (rawData) => {
      let data;
      data = typeof rawData === "string" ? JSON.parse(rawData) : rawData;
      const normalizedStatus = data?.status === "send" ? "sent" : data?.status;
      setMessages((prev) =>
        prev.map((msg) =>
          msg.whatsappMessageId === data?.whatsappMessageId
            ? { ...msg, status: normalizedStatus }
            : msg
        )
      );
    };
    socket.on("messageStatusUpdate", handleStatusUpdate);
  }, []);

  const messageSend = async () => {
    setButtonLoading(true);
    if (!message.trim() && !uploadImage) return;
    const payload = {
      content: message.replace(/\\n/g, "\n"),
      contentType: contentType ? contentType : "text",
      touser: userId,
      file: uploadImage,
    };
    const response = await dispatch(sendMessage(payload));
    if (sendMessage.fulfilled.match(response)) {
      const { data } = response.payload;
      setButtonLoading(false);
      const newMsg = {
        content: message,
        contentType: data?.contentType,
        fileDetails: data?.fileDetails,
        receiver: userId,
        createdAt: new Date().toISOString(),
        whatsappMessageId: data?.whatsappMessageId,
        status: "sent",
      };

      setMessages((prev) => [...prev, newMsg]);
      setMessage("");
      setUploadImage("");
      setImages();
      scrollToBottom();
    } else {
      console.error("Message send failed:", response);
    }
  };

  const handleLoadMore = () => {
    setPage((prev) => prev + 1);
  };
  // upload dosc
  const handleFileUpload = (e) => {
    const contentType = e.target.files[0]?.type?.startsWith("image/")
      ? "image"
      : e.target.files[0]?.type?.startsWith("video/")
      ? "video"
      : [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ].includes(e.target.files[0]?.type)
      ? "document"
      : "unknown";
    setContentType(contentType);
    setImages(URL.createObjectURL(e.target.files?.[0]));
    setUploadImage(e.target.files?.[0]);
  };
  const triggerFileInput = () => {
    fileInputRef.current.click(); // trigger hidden input
  };

  let userWindowCloseSession = false;

  return (
    <Col
      md={8}
      xs={8}
      className={`max-100vh chat-window d-flex flex-column w-100 ${
        userId ? `` : `justify-content-center text-center`
      }`}
    >
      {userId ? (
        <>
          <div className="chat-header p-3 border-bottom">
            <h6 className="mb-0 d-flex align-items-center">
              <div
                className={`rounded-circle text-white d-flex align-items-center justify-content-center me-2 ${
                  tempUser === "true" ? `bg-primary` : `bg-success`
                }`}
                style={{
                  height: "50px",
                  width: "50px",
                  fontSize: "20px",
                  fontWeight: "bold",
                }}
              >
                {(tempUser === "true" ? username : name)
                  ?.charAt(0)
                  .toUpperCase()}
              </div>
              {tempUser === "true" ? `${username} (${name})` : name}
            </h6>
          </div>

          <div
            ref={chatBodyRef}
            className="chat-body pt-0 flex-grow-1 p-3 overflow-auto"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div className="position-sticky top-0 text-center mb-2 bg-white chat-msg py-2">
              <span
                className="text-muted small chat-msg msg"
                onClick={handleLoadMore}
                style={{ cursor: "pointer" }}
              >
                <i className="bi bi-arrow-repeat"></i> Seeking older messages
              </span>
            </div>
            {messages.map((item, index) => {
              const currentDate = moment(item.createdAt).format("DD-MM-YYYY");
              const prevDate =
                index > 0
                  ? moment(messages[index - 1].createdAt).format("DD-MM-YYYY")
                  : null;
              const showDate = currentDate !== prevDate;
              // Find the last message sent *by* the current user (not received by them)
              userWindowCloseSession =
                customerLastMsgTime &&
                new Date(customerLastMsgTime).getTime() <=
                  Date.now() - 24 * 60 * 60 * 1000;
              return (
                <Fragment key={index}>
                  {showDate && (
                    <div className="text-center text-muted small mb-2">
                      <b>{currentDate}</b>
                    </div>
                  )}
                  {item?.receiver === userId ? (
                    <div className="chat-msg text-end mb-2">
                      <div className="admin-message-align">
                        {item?.template &&
                          item?.templateInputs?.[0]?.type === "IMAGE" && (
                            <img src={item?.templateInputs?.[0]?.text} />
                          )}
                        <span className="msg px-2 text-black d-inline-block pl-2 py-2 rounded-3">
                          {item?.contentType === "image" && (
                            <>
                              <img
                                onClick={() =>
                                  window.open(
                                    `${baseUrl}/api/getfile/${item?.fileDetails?.id}`,
                                    "_blank"
                                  )
                                }
                                className="w-50"
                                src={`${baseUrl}/api/getfile/${item?.fileDetails?.id}`}
                              />
                              <br />
                            </>
                          )}
                          {item?.contentType === "document" && (
                            <>
                              <Button
                                onClick={() =>
                                  window.open(
                                    `${baseUrl}/api/getfile/${item?.fileDetails?.id}`,
                                    "_blank"
                                  )
                                }
                              >
                                View Document
                              </Button>
                              <br />
                            </>
                          )}
                          {item?.contentType === "video" && (
                            <>
                              <video controls>
                                <source
                                  src={`${baseUrl}/api/getfile/${item?.fileDetails?.id}`}
                                  type="video/mp4"
                                />
                              </video>
                              <br />
                            </>
                          )}
                          {(item?.content !== "") && (
                              <span
                                className="msg bg-gary d-inline-block px-3 py-2 rounded-3 text-justify"
                                dangerouslySetInnerHTML={{
                                  __html: item?.content
                                    ?.replace(/\n/g, "<br>")
                                    ?.replace(/\*(.*?)\*/g, "<b>$1</b>"),
                                }}
                              />
                            )}
                          {item.status === "sent" && (
                            <i className="bi bi-check t ms-2 text-secondary bi-check-p"></i>
                          )}
                          {item.status === "delivered" && (
                            <i className="bi bi-check-all  ms-2 text-secondary bi-check-p"></i>
                          )}
                          {item.status === "read" && (
                            <i className="bi bi-check-all text-primary  ms-2 bi-check-p"></i>
                          )}
                        </span>
                        <div className="text-muted small mt-1">
                          {moment(item.createdAt).format("HH:mm")}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="chat-msg m-w-80 text-start mb-2">
                      {item?.contentType === "image" && (
                        <>
                          <img
                            onClick={() =>
                              window.open(
                                `${baseUrl}/api/getfile/${item?.fileDetails?.id}`,
                                "_blank"
                              )
                            }
                            className="w-50"
                            src={`${baseUrl}/api/getfile/${item?.fileDetails?.id}`}
                          />
                          <br />
                        </>
                      )}
                      {item?.contentType === "document" && (
                        <Button
                          onClick={() =>
                            window.open(
                              `${baseUrl}/api/getfile/${item?.fileDetails?.id}`,
                              "_blank"
                            )
                          }
                        >
                          View Document
                        </Button>
                      )}
                      {item?.contentType === "video" && (
                        <>
                          <video controls>
                            <source
                              src={`${baseUrl}/api/getfile/${item?.fileDetails?.id}`}
                              type="video/mp4"
                            />
                          </video>
                          <br />
                        </>
                      )}
                      {(item?.content !== "") && (
                          <span
                            className="msg bg-gary d-inline-block px-3 py-2 rounded-3"
                            dangerouslySetInnerHTML={{
                              __html:
                                item?.contentType === "text"
                                  ? item?.content
                                  : item?.fileDetails?.caption
                                      ?.replace(/\n/g, "<br>")
                                      ?.replace(/\*(.*?)\*/g, "<b>$1</b>"),
                            }}
                          />
                        )}
                      <div className="text-muted small">
                        {moment(item.createdAt).format("HH:mm")}
                      </div>
                    </div>
                  )}
                </Fragment>
              );
            })}
          </div>

          <div className="chat-footer py-3 border-top">
            <Row
              className="flex-nowrap overflow-auto"
              style={{ whiteSpace: "nowrap" }}
            >
              {whatsappTemplateList?.map((item, index) => (
                <span
                  key={index}
                  className="flex-shrink-0"
                  style={{ width: "auto" }}
                >
                  <strong
                    onClick={() => {
                      setSelectedTemp(item?.name);
                      setTempReco(item?.components);
                      setTemInputFields(item?.numberOfInput);
                      dispatch(
                        getWhatsappTemplateVarCount({
                          tempName: item?.name,
                          languageCode: item?.language,
                        })
                      );
                    }}
                    className={`d-inline-block px-3 py-2 rounded-3 me-2 cursor-pointer ${
                      selectedTemp === item?.name
                        ? `bg-success text-white`
                        : `bg-info text-black`
                    }`}
                  >
                    {item?.name}{" "}
                    <i className="bi bi-arrow-right-circle-fill"></i>
                  </strong>
                </span>
              ))}
            </Row>
            <TemplateInputFields
              whtspVarCount={whtspVarCount}
              selectedTemp={selectedTemp}
              setSelectedTemp={setSelectedTemp}
              setTempReco={setTempReco}
              tempReco={tempReco}
            />
            {/* upload files */}
            <div className="mt-3 d-flex">
              <img
                    className="upload-img-size p-1"
                    src={images}
                  />
              {/* {images?.map((img, index) => (
                <Fragment key={index}>
                  <img
                    className="upload-img-size p-1"
                    src={img}
                    alt={`uploaded-${index}`}
                  />
                  <i
                    onClick={() => handleDeleteImage(index)}
                    className="bi bi-x bg-danger delete-img"
                  ></i>
                </Fragment>
              ))} */}
            </div>
            {!userWindowCloseSession && (
              <InputGroup>
                <Form.Control
                  as="textarea"
                  placeholder="Type a message..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault(); // prevent new line
                      if (!buttonLoading) messageSend();
                    }
                  }}
                />
                <Button
                  className="border"
                  disabled={buttonLoading}
                  variant="warning"
                  onClick={triggerFileInput}
                >
                  <i className="bi bi-upload"></i>
                </Button>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileUpload}
                   accept=".png, .jpg, .jpeg, .pdf"
                  style={{ display: "none" }}
                />
                {/* upload files end*/}
                {
                  <Button
                    className="border text-white"
                    disabled={buttonLoading ? true : false}
                    variant="success"
                    onClick={messageSend}
                  >
                    Send
                  </Button>
                }
              </InputGroup>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="d-flex justify-content-center">
            <img src={icon} alt="" style={{ width: "25%" }} />
          </div>
          <h1 className="text-center my-3">
            Quick & Reliable Customer Chat Support
          </h1>
          <p>
            For quick and reliable assistance, our Chat Support is always here
            to help you — get the answers you need in real-time, without the
            wait!
          </p>
        </>
      )}
    </Col>
  );
};

export default ChatArea;
